module.exports = __webpack_public_path__ + "img/jackpot-m-bg.005ca879.png";